import React, {useEffect} from "react";
import "./Input.scss";
import Dropdown from "react-dropdown";
import { Multiselect } from "multiselect-react-dropdown";
import ReactTags from 'react-tag-autocomplete'
import Icon from "../Icon";
import FeatherIcon from "feather-icons-react"
import Search from "../Search";
import SearchFood from "../../_mealplans/SearchFood";

export default function Input({ ref, readOnly, style, type, maxLength,tags, error, min, max,placeholder, label, onChange, searchItems, value, options, onRemove, onSelect, rows, cols, onClick, className }) {
  // console.log("value ",value)
  useEffect(() => {
    
  }, [searchItems])
  // console.log("debuging brwoser freezing")
  function TagComponent({ tag, removeButtonText, onDelete }) {
    return (
      <button className="c-tag-pil" type='button' title={removeButtonText} onClick={onDelete}>
       <p> {tag.name}</p>
       <FeatherIcon icon="x" size="13" color="#000" />
      </button>
    )
  }
  return (
    <div className="c-input-wrapper">
      <span>{label ? label : "Text"}</span>
      {type === "select" ? (
        <Dropdown  options={options?.filter((e) => e !== (value ? value : options[0]))} onChange={(e) => onChange(e.value)} value={value ? value : options[0]} arrowClosed={<Icon icon="arrow-down" height={15} size={15} />} arrowOpen={<Icon icon="arrow-up" height={15} size={15} />} />
      ) : type === "multi" ? (
        <>
        {/* <Multiselect disablePreSelectedValues={true} isObject={false} emptyRecordMsg={emptyRecordMsg ? emptyRecordMsg : "No options"} options={options} selectedValues={value}  onSelect={(e) => onSelect(e)} onSearch={(e) => onChange(e)}  onRemove={(e) => onRemove(e)}  displayValue="name"  id="c-multi-select" closeIcon="cancel" /> */}
        <ReactTags tagComponent={TagComponent}  tags={tags} suggestions={options} onDelete={onRemove} onAddition={onSelect} onInput={onChange} />
        </>
      ) : type === "textarea" ? (
        <input type={type ? type : "textarea"}  placeholder={placeholder ? placeholder : "Placeholder"} value={value} onChange={(e) => (onChange ? onChange(e.target.value) : {})} rows={rows ? rows : 3} cols={cols ? cols : 3} />
      ) : type === "search" ? (
        <>
        <div className="c-input-search">
          <Search isOpen={() => {}} response={searchItems}  filterClients={() => {}} onClick={(e) => onClick(e)} placeholder={placeholder ? placeholder : "Placeholder"}/>
        </div>
        {error && (
          <p className="c-default-error-message">{error}</p>
        )}
        </>
      ): type === "search-food" ? (
        <>
        <div className="c-input-search">
         <SearchFood onClick={(e) => onClick(e)} value={value? value : ""} onChange={(e) => onChange(e.target.value)}/>
        </div>
        {error && (
          <p className="c-default-error-message">{error}</p>
        )}
        </>
      ) : type === "number" ? (
        <>
        <input style={style} className={className} min={min} max={max} type={type ? type : "number"} placeholder={placeholder ? placeholder : "Placeholder"} value={value} onChange={(e) => (onChange ? onChange(e.target.value) : {})} />
        {error && (
          <p className="c-default-error-message">{error}</p>
        )}
        </>
      ) : (
        <>
        <input type={type ? type : "text"} ref={ref} readOnly={readOnly} maxLength={maxLength} style={style} placeholder={placeholder ? placeholder : "Placeholder"} value={value} onChange={(e) => (onChange ? onChange(e.target.value) : {})} />
        {error && (
          <p className="c-default-error-message">{error}</p>
        )}
        </>
      )}
    </div>
  );
}
